import * as React from 'react'

const SvgTranscriptIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.406 18.125h1.344L15 8.75h-1.469l-3.75 9.375h1.344l1-2.5h4.281l1 2.5zm-4.781-3.75l1.637-4.1 1.644 4.1h-3.281zm-1.375-10v-1.25H6.875V1.25h-1.25v1.875H1.25v1.25h6.713a9.194 9.194 0 01-1.994 3.863 8.438 8.438 0 01-1.432-2.613H3.225A10.294 10.294 0 005.1 9.113a10.524 10.524 0 01-3.225 2.137l.469 1.162A11.544 11.544 0 005.956 10a10.574 10.574 0 003.6 2.4L10 11.25a9.05 9.05 0 01-3.2-2.106 11.025 11.025 0 002.45-4.769h2z"
      fill="#163250"
    />
  </svg>
)

export default SvgTranscriptIcon
